import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ProfileFormComponent } from './account/profile-form/profile-form.component';
import { RegisterComponent } from './account/register/register.component';
import { NovoConvertidoComponent } from './account/novo-convertido/novo-convertido.component';
import { AreaFormComponent } from './area/area-form/area-form.component';
import { AreaListComponent } from './area/area-list/area-list.component';
import { AreaViewComponent } from './area/area-view/area-view.component';
import { ChangePasswordComponent } from './auth/change-password/change-password.component';
import { LoginComponent } from './auth/login/login.component';
import { RequestPasswordComponent } from './auth/request-password/request-password.component';
import { ChildrenFormComponent } from './children/children-form/children-form.component';
import { ChildrenViewComponent } from './children/children-view/children-view.component';
import { ChilrenListComponent } from './children/chilren-list/chilren-list.component';
import { NavigatorWithMenuComponent } from './components/navigator-with-menu/navigator-with-menu.component';
import { NavigatorComponent } from './components/navigator/navigator.component';
import { DashboardComponent } from './dashboard/dashboard/dashboard.component';
import { HomeComponent } from './dashboard/home/home.component';
import { FrequencyFormComponent } from './frequency/frequency-form/frequency-form.component';
import { FrequencyListComponent } from './frequency/frequency-list/frequency-list.component';
import { FrequencyReportComponent } from './frequency/frequency-report/frequency-report.component';
import { FrequencyViewComponent } from './frequency/frequency-view/frequency-view.component';
import { GroupWordFormComponent } from './group-word/group-word-form/group-word-form.component';
import { GroupWordListComponent } from './group-word/group-word-list/group-word-list.component';
import { GroupWordViewComponent } from './group-word/group-word-view/group-word-view.component';
import { GroupFormComponent } from './group/group-form/group-form.component';
import { GroupListComponent } from './group/group-list/group-list.component';
import { GroupViewComponent } from './group/group-view/group-view.component';
import { AuthGuard } from './guards/auth.guard';
import { MemberFormComponent } from './members/member-form/member-form.component';
import { MemberListComponent } from './members/member-list/member-list.component';
import { MemberViewComponent } from './members/member-view/member-view.component';
import { NotFoundComponent } from './outher-pages/not-found/not-found.component';
import { PatrimonyFormComponent } from './patrimony/patrimony-form/patrimony-form.component';
import { PatrimonyListComponent } from './patrimony/patrimony-list/patrimony-list.component';
import { PatrimonyViewComponent } from './patrimony/patrimony-view/patrimony-view.component';

import { SectorFormComponent } from './sector/sector-form/sector-form.component';
import { SectorListComponent } from './sector/sector-list/sector-list.component';
import { SectorViewComponent } from './sector/sector-view/sector-view.component';
import { ScrollComponent } from './scroll/scroll.component';
import { TermsComponent } from './pages/terms/terms.component';
import { TermOfServiceV1Component } from './others/term-of-service-v1/term-of-service-v1.component';
import { TermOfServiceV1PublicComponent } from './others/term-of-service-v1-public/term-of-service-v1-public.component';
import { BannerListComponent } from './banner/banner-list/banner-list.component';
import { PermissionsHomeComponent } from './permissions/permissions-home/permissions-home.component';
import { PermissionsSectionComponent } from './permissions/permissions-section/permissions-section.component';
import { PermissionsRulesComponent } from './permissions/permissions-rules/permissions-rules.component';
import { QuizListComponent } from './quiz/quiz-list/quiz-list.component';
import { QuizFormComponent } from './quiz/quiz-form/quiz-form.component';

import { QuizViewComponent } from './quiz/quiz-view/quiz-view.component';
import { QuizRespondComponent } from './quiz/quiz-respond/quiz-respond.component';
import { QuizReviewComponent } from './quiz/quiz-review/quiz-review.component';

const routes: Routes = [
  {
    path: '',
    component: NavigatorComponent,
    children: [
      { path: '', component: LoginComponent },
      {
        path: 'request-password/:hash',
        component: RequestPasswordComponent,
      },
      {
        path: 'cadastrar',
        component: RegisterComponent,
      },
      {
        path: 'novo-convertido',
        component: NovoConvertidoComponent,
      },
      {
        path: 'terms',
        component: TermsComponent,
      },
      {
        path: 'aceitarTermos',
        component: TermOfServiceV1PublicComponent,
      },
    ],
  },
  {
    path: '',
    component: NavigatorWithMenuComponent,
    children: [
      { path: 'changePassword', component: ChangePasswordComponent },
      {
        path: 'dashboard',
        component: DashboardComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'home',
        component: HomeComponent,
        canActivate: [AuthGuard],
      },
      { path: 'membro', component: MemberListComponent, canActivate: [AuthGuard] },
      {
        path: 'membro/add',
        component: MemberFormComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'membro/:id',
        component: MemberFormComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'membro/vizualizar/:id',
        component: MemberViewComponent,
        canActivate: [AuthGuard],
      },
      { path: 'area', component: AreaListComponent, canActivate: [AuthGuard] },
      { path: 'area/add', component: AreaFormComponent, canActivate: [AuthGuard] },
      { path: 'area/:id', component: AreaFormComponent, canActivate: [AuthGuard] },
      {
        path: 'area/vizualizar/:id',
        component: AreaViewComponent,
        canActivate: [AuthGuard],
      },
      { path: 'setor', component: SectorListComponent, canActivate: [AuthGuard] },
      {
        path: 'setor/add',
        component: SectorFormComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'setor/:id',
        component: SectorFormComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'setor/vizualizar/:id',
        component: SectorViewComponent,
        canActivate: [AuthGuard],
      },
      { path: 'celula', component: GroupListComponent, canActivate: [AuthGuard] },
      {
        path: 'celula/add',
        component: GroupFormComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'celula/:id',
        component: GroupFormComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'celula/vizualizar/:id',
        component: GroupViewComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'patrimonio',
        component: PatrimonyListComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'patrimonio/add',
        component: PatrimonyFormComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'patrimonio/:id',
        component: PatrimonyFormComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'patrimonio/vizualizar/:id',
        component: PatrimonyViewComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'frequencia/add',
        component: FrequencyFormComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'frequencia',
        component: FrequencyListComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'frequencia/vizualizar/:id',
        component: FrequencyViewComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'palavra/add',
        component: GroupWordFormComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'palavra',
        component: GroupWordListComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'palavra/vizualizar/:id',
        component: GroupWordViewComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'minha-conta',
        component: ProfileFormComponent,
      },
      {
        path: 'crianca/add',
        component: ChildrenFormComponent,
      },
      {
        path: 'crianca/:id',
        component: ChildrenFormComponent,
      },
      {
        path: 'crianca/vizualizar/:id',
        component: ChildrenViewComponent,
      },
      {
        path: 'crianca',
        component: ChilrenListComponent,
      },
      {
        path: 'frequencia/relatorio',
        component: FrequencyReportComponent,
      },
      {
        path: 'frequencia/relatorio',
        component: FrequencyReportComponent,
      },
      {
        path: 'termosDeServico',
        component: TermOfServiceV1Component,
      },
      {
        path: 'banners',
        component: BannerListComponent,
      },
      {
        path: 'devocional',
        component: QuizListComponent,
      },
      {
        path: 'devocional/form/new',
        component: QuizFormComponent,
      },
      {
        path: 'devocional/form/:id',
        component: QuizFormComponent,
      },
      {
        path: 'devocional/view/:id',
        component: QuizViewComponent,
      },
      {
        path: 'devocional/respond/:id',
        component: QuizRespondComponent,
      },
      {
        path: 'devocional/review/:id',
        component: QuizReviewComponent,
      },
      {
        path: 'permissoes',
        component: PermissionsHomeComponent,
      },
      {
        path: 'permissoes/regras',
        component: PermissionsRulesComponent,
      },
      {
        path: 'permissoes/funcoes',
        component: PermissionsSectionComponent,
        data: { title: 'Funções' },
      },
      {
        path: 'permissoes/roles',
        component: PermissionsSectionComponent,
        data: { title: 'Roles' },
      },
      {
        path: 'permissoes/entidades',
        component: PermissionsSectionComponent,
        data: { title: 'Entidades' },
      },
    ],
  },

  {
    path: '404',
    component: NotFoundComponent,
  },
  {
    path: '**',
    component: NotFoundComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
